'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var aboutus = exports.aboutus = {
  title: 'About Tutellus',
  our_mission: 'Our Goal:',
  description: 'To bring Education to every corner of the world',
  our_team: 'Our Team:',
  about: JSON.stringify(['Tutellus is the leading online collaborative EdTech platform.', 'Our product combines design, simplicity and technology, creating a social, easy and fun experience.', 'We have users from over 160 countries, with nearly a million students, and are headquartered in Madrid, Spain.']),
  mcaballero_name: 'Miguel Caballero',
  mcaballero_role: 'CEO',
  jortiz_name: 'Javier Ortiz',
  jortiz_role: 'CTO',
  clopez_name: 'Carlos López',
  clopez_role: 'Backend Dev',
  karol_name: 'Karolina Szymanczak',
  karol_role: 'Designer',
  jcalvo_name: 'Javier Calvo',
  jcalvo_role: 'Data Scientist',
  dsevilla_name: 'David Sevilla',
  dsevilla_role: 'Scholar',
  cofounder: 'Co-Founder'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/aboutus.js
// module id = 709
// module chunks = 0